var _rect, _rect2, _rect3, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 89,
    rx: 10,
    fill: "#019371"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 86,
    height: 86,
    rx: 8.5,
    fill: "#019371",
    stroke: "#D7FFC2",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_767_758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 89
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 88,
    rx: 9.5,
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_767_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33.0002 29.778C67.9997 23.2112 8.99969 98.7112 77.3051 96.9498",
    stroke: "#D7FFC2",
    strokeOpacity: 0.34,
    strokeWidth: 2.2069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.863 63.2483C45.9703 44.2078 89.3431 20.0392 51 -33.2482",
    stroke: "#D7FFC2",
    strokeOpacity: 0.34,
    strokeWidth: 2.2069
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_767_758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 27.5,
    width: 32,
    height: 37,
    rx: 3.5,
    stroke: "#019371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 22C35.447 22 35 22.448 35 23V26H58V50.7852C58.312 50.6002 58.5958 50.3923 58.8418 50.1523C59.6208 49.3873 60 48.356 60 47C60 46.447 60.447 46 61 46C61.553 46 62 46.447 62 47C62 48.895 61.4082 50.4351 60.2422 51.5781C59.6102 52.1971 58.842 52.6519 58 53.0039V58H65C65.553 58 66 57.552 66 57V23C66 22.448 65.553 22 65 22H36ZM26 28C25.448 28 25 28.448 25 29V63C25 63.553 25.448 64 26 64H55C55.553 64 56 63.553 56 63V53.627C54.359 53.973 52.561 54.0508 50.832 54.0508C50.097 54.0508 49.3737 54.0364 48.6797 54.0234C48.2387 54.0144 47.821 54.0079 47.418 54.0039L49.707 56.293C50.098 56.684 50.098 57.316 49.707 57.707C49.512 57.902 49.256 58 49 58C48.744 58 48.488 57.902 48.293 57.707L44.293 53.707C43.902 53.316 43.902 52.684 44.293 52.293L48.293 48.293C48.684 47.902 49.316 47.902 49.707 48.293C50.098 48.684 50.098 49.316 49.707 49.707L47.4102 52.0039C47.8282 52.0079 48.2618 52.0134 48.7188 52.0234C50.9657 52.0644 53.763 52.1165 56 51.5605V29C56 28.448 55.553 28 55 28H26ZM32 34H49C49.553 34 50 34.448 50 35C50 35.552 49.553 36 49 36H32C31.448 36 31 35.552 31 35C31 34.448 31.448 34 32 34ZM32 40H49C49.553 40 50 40.448 50 41C50 41.552 49.553 42 49 42H32C31.448 42 31 41.552 31 41C31 40.448 31.448 40 32 40ZM32 46H42C42.552 46 43 46.447 43 47C43 47.553 42.552 48 42 48H32C31.448 48 31 47.553 31 47C31 46.447 31.448 46 32 46Z",
    fill: "#D0FFBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_767_758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCopyIcon);
export default __webpack_public_path__ + "static/media/lpCopy_icon.1e01029bfe06bb985dd64a2b673d8f5a.svg";
export { ForwardRef as ReactComponent };